import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { Delete, ZoomIn } from '@mui/icons-material';
import { Storage } from 'aws-amplify';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import * as UserActions from '../../../../../core/users/action';

export default function CardAssetPhotoList({ asset }) {
  const dispatch = useDispatch();
  const [imageUrl, setImageUrl] = useState();
  const [openDialog, setOpenDialog] = useState();

  useEffect(() => {
    (async () => {
      try {
        const signedURL = await Storage.get(asset?.s3_object_key); // get key from Storage.list
        setImageUrl(signedURL);
      } catch (error) {
        console.log('Error getting asset ', error);
      }
    })();
  }, []);

  const handleDelete = async () => {
    try {
      const deleteAsset = await Storage.remove(asset?.s3_object_key);
      if (deleteAsset) dispatch(UserActions.deleteUserAsset(asset.id));
    } catch (error) {
      console.log('Error deleting asset ', error);
    }
  };

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <ImageListItem key={asset.id}>
        <img src={`${imageUrl}`} srcSet={`${imageUrl}`} alt={asset.type_of_asset} />
        <ImageListItemBar
          title="Asset"
          subtitle={asset.type_of_asset}
          actionIcon={
            <IconButton sx={{ color: 'rgba(255, 255, 255, 0.54)' }} aria-label="info about">
              <ZoomIn color="success" onClick={handleClickOpen} />
              <Delete color="error" onClick={handleDelete} />
            </IconButton>
          }
        />
      </ImageListItem>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogContent>
          <img src={`${imageUrl}`} srcSet={`${imageUrl}`} alt={asset.type_of_asset} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

CardAssetPhotoList.propTypes = {
  asset: PropTypes.instanceOf(Object).isRequired,
};
